import { all, call, put, take } from 'redux-saga/effects';

import { addNotificationAction } from 'store/notifications/notificationsActions';

import {
  fetchInstrument,
  postOrder,
  fetchInstrumentDocuments,
  fetchInstrumentProducts,
  fetchArtifacts,
} from 'services';

import {
  GET_INSTRUMENT_SUCCESS,
  GET_INSTRUMENT_ERROR,
  GET_INSTRUMENT_DOCUMENTS_SUCCESS,
  GET_INSTRUMENT_DOCUMENTS_ERROR,
  GET_INSTRUMENT_PRODUCTS_SUCCESS,
  GET_INSTRUMENT_PRODUCTS_ERROR,
  GET_INSTRUMENT_RATING_NEWS_SUCCESS,
  GET_INSTRUMENT_RATING_NEWS_ERROR,
  GET_INSTRUMENT_RESEARCH_SUCCESS,
  GET_INSTRUMENT_RESEARCH_ERROR,
  REQUEST_INSTRUMENT_RATING_SUCCESS,
  REQUEST_INSTRUMENT_RATING_ERROR,
  REQUEST_INSTRUMENT_RATING_AND_FETCH_DATA_SUCCESS,
  REQUEST_INSTRUMENT_RATING_AND_FETCH_DATA_ERROR,
  getInstrumentDocumentsAction,
  getInstrumentProductsAction,
  requestInstrumentRatingAction,
} from './instrumentActions';

export function* fetchInstrumentSaga({ payload }) {
  try {
    const response = yield call(fetchInstrument, payload);
    yield put({ type: GET_INSTRUMENT_SUCCESS, payload: response });
  } catch (response) {
    yield put({ type: GET_INSTRUMENT_ERROR, payload: response });
  }
}

export function* fetchInstrumentDocumentsSaga({ payload }) {
  try {
    const response = yield call(fetchInstrumentDocuments, payload);
    yield put({ type: GET_INSTRUMENT_DOCUMENTS_SUCCESS, payload: response });
  } catch (response) {
    yield put({ type: GET_INSTRUMENT_DOCUMENTS_ERROR, payload: response });
  }
}

export function* fetchInstrumentProductsSaga({ payload }) {
  try {
    const response = yield call(fetchInstrumentProducts, payload);
    yield put({ type: GET_INSTRUMENT_PRODUCTS_SUCCESS, payload: response });
  } catch (response) {
    yield put({ type: GET_INSTRUMENT_PRODUCTS_ERROR, payload: response });
  }
}

export function* fetchInstrumentRatingNewsSaga({ payload }) {
  try {
    const response = yield call(fetchArtifacts, payload);
    yield put({ type: GET_INSTRUMENT_RATING_NEWS_SUCCESS, payload: response });
  } catch (response) {
    yield put({ type: GET_INSTRUMENT_RATING_NEWS_ERROR, payload: response });
  }
}

export function* fetchInstrumentResearchSaga({ payload }) {
  try {
    const response = yield call(fetchArtifacts, payload);
    yield put({ type: GET_INSTRUMENT_RESEARCH_SUCCESS, payload: response });
  } catch (response) {
    yield put({ type: GET_INSTRUMENT_RESEARCH_ERROR, payload: response });
  }
}

export function* requestInstrumentRatingSaga({ payload }) {
  try {
    yield call(postOrder, payload);
    yield put({ type: REQUEST_INSTRUMENT_RATING_SUCCESS });
    yield put(
      addNotificationAction({
        message: 'Your request was successfully submitted.',
        variant: 'success',
      }),
    );
  } catch (response) {
    yield put({ type: REQUEST_INSTRUMENT_RATING_ERROR, payload: response });
    yield put(
      addNotificationAction({ message: 'Failed to submit the request.', variant: 'error' }),
    );
  }
}

export function* requestInstrumentRatingAndFetchData({ payload }) {
  try {
    yield put(requestInstrumentRatingAction(payload));
    yield take(REQUEST_INSTRUMENT_RATING_SUCCESS);
    const { id } = payload;

    yield all([
      put(getInstrumentDocumentsAction({ instrumentId: id })),
      put(getInstrumentProductsAction({ instrumentId: id })),
    ]);
    yield all([take(GET_INSTRUMENT_DOCUMENTS_SUCCESS), take(GET_INSTRUMENT_PRODUCTS_SUCCESS)]);

    yield put({ type: REQUEST_INSTRUMENT_RATING_AND_FETCH_DATA_SUCCESS });
  } catch (response) {
    yield put({ type: REQUEST_INSTRUMENT_RATING_AND_FETCH_DATA_ERROR, payload: response });
  }
}
